export const bronzeCircle = require("assets/BronzeCircle.png")
export const silverCircle = require("assets/SilverCircle.png")
export const goldCircle = require("assets/GoldCircle.png")
export const platiniumCircle = require("assets/PlatiniumCircle.png")

export const bronze = require("assets/Bronze.png")
export const silver = require("assets/Silver.png")
export const gold = require("assets/Gold.png")
export const platinium = require("assets/Platinium.png")
